import { v4 as uuid } from 'uuid'
import Transport from '@/common/classes/Transport'
import { PersonalIdentifications } from '@/common/enums/PersonalIdentifications'
import { OrganizationSubjects } from '@/enums/OrganizationSubjects'

export default class Visitor {
  docError = false
  personal = {
    fullname_last: null,
    fullname_first: null,
    fullname_patronymic: null,
    identification_id: PersonalIdentifications.PASSPORT,
    nationality_id: 182,
    identification_number: null,
    identification_code: null,
    identification_place: null,
    identification_date_of: null,
    address: null,
    actual_address: null,
    actual_address_matches: false,
    identification_date_to: null,
    birthday: null,
    placebirth: null,
    organization_name: null,
    organization_inn: null,
    status: null,
    errorIdentificationNumber: false,
    hint: null,
    dataSelected: null,
    visitorErr: null,
    visitorOrganizationErr: null,
    innControlSumErr: false,
    phone: '',
    infoBlock: null,
    fedSfm: {},
    patronymic_missing: false,
    residence: false,
    organization_subject_id: OrganizationSubjects.Entity,
    organization_nationality_id: 182,
    require_other_organization: false,
    subdivision_id: null,
    inn: null,
    snils: null
  }

  transports = []
  files = {}
  access = 0
  personalUnits = []
  uuid = uuid()

  constructor(object) {
    if (object) {
      object.transports = object?.transports.map((transport) => new Transport(transport)) ?? []
      Object.assign(this, object)
    }
  }
}
